import React from 'react';
export function Footer() {
  return <footer className="bg-deco-text text-deco-card py-10 px-4 text-center" data-id="element-59" data-mp="32wd0e9mw79qd">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-4" data-id="element-60" data-mp="3ggarlxr3gh6i">
        <img src="https://cdn.magicpatterns.com/uploads/6V1fDAXu7rVeR9gEB5BN1k/LOGO_DECOEMPRENDE.png" alt="Deco Emprende" className="h-16 object-contain opacity-80 brightness-0 invert" data-id="element-61" data-mp="32o48q3wk3w3d" />
        <h3 className="font-serif text-lg sm:text-xl text-deco-warm/80 tracking-wide" data-id="element-62" data-mp="3uf0mr7ucs6s8">
          Falso Vitral Deco
        </h3>
        <div className="w-12 h-px bg-deco-card/20 my-2" data-id="element-63" data-mp="38zbozae1d6l" />
        <p className="text-deco-card/50 text-xs sm:text-sm" data-id="element-64" data-mp="36d1erw44jko">
          © {new Date().getFullYear()} Deco Emprende. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}